import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { api } from "../../api";
import { YANDEX_COUNTRIES } from "../../config";
import { userStore } from "../../stores/userStore";
import { GoogleSocialAccount } from "./GoogleSocialAccount";
import { TelegramSocialAccount } from "./TelegramSocialAccount";
import { YandexSocialAccount } from "./YandexSocialAccount";

import "./ProfileSocialAccounts.css";

export const ProfileSocialAccounts = observer(function ProfileSocialAccounts() {
  const { t, i18n } = useTranslation();
  const [geoIpCountry, setGeoIpCountry] = useState<string | null>(
    () => api.countries.getCachedCurrentCountry(i18n.language)?.code ?? null,
  );
  const profile = userStore.profile;
  const isYandexLinked = Boolean(
    profile?.integrations?.social_list?.some(
      (account) => account.id === "yandex",
    ),
  );
  const showYandex =
    isYandexLinked ||
    (profile?.country != null && YANDEX_COUNTRIES.has(profile.country)) ||
    (geoIpCountry != null && YANDEX_COUNTRIES.has(geoIpCountry));

  useEffect(() => {
    api.countries
      .getCurrentCountry(i18n.language)
      .then((current) => setGeoIpCountry(current.code))
      .catch(() => setGeoIpCountry(null));
  }, [i18n.language]);

  return (
    <div className="social-accounts">
      <h3>{t("profile.socialAccounts.title")}</h3>
      <ul className="social-accounts__list">
        {!userStore.isRuRegion && (
          <li>
            <GoogleSocialAccount />
          </li>
        )}
        {showYandex && (
          <li>
            <YandexSocialAccount />
          </li>
        )}
        <li>
          <TelegramSocialAccount />
        </li>
      </ul>
    </div>
  );
});
